export default "__VITE_ASSET__6rb4pZk1__"